<script lang="ts" setup>
import AppLogo from './AppLogo.vue'

defineOptions({
  name: 'LogoSun',
})
</script>

<template>
  <div class="logo-sun">
    <AppLogo
      type="mark"
      color="inverse"
    />
  </div>
</template>

<style scoped lang="scss" src="./LogoSun.scss" />
